export default __webpack_public_path__ + "static/media/vitro_linc.0d0884a4.svg";